import { useState } from "react";
import { faqItems } from "@/mocks/faqItems";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="w-full">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="盲盒小百科"
          title="关于盲盒与试吃，常被问到的问题"
          desc="整理了一些刚接触零食盲盒时最常遇到的疑问，内容为一般性说明，帮助你在开箱前有个大概了解。"
          align="center"
        />

        <div className="mx-auto mt-8 max-w-3xl">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border bg-background-50 ${
                  isOpen ? "border-primary-300" : "border-background-200"
                } ${index !== 0 ? "mt-3" : ""}`}
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i
                      className={
                        isOpen ? "ri-subtract-line text-sm" : "ri-add-line text-sm"
                      }
                    />
                  </span>
                </button>
                {isOpen ? (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}